import { Routes } from '@angular/router';
import { LandingPageComponent } from '../components/landing-page/landing-page.component';
import { PageNotFoundComponent } from '../components/page-not-found/page-not-found.component';
import { pwaLaunchGuard } from '../guards/pwa-launch.guard';
import { AbstractRouteGuard } from '../modules/microsoft-authentication-library/route-guard/route-guard.abstract';
import { NavigationRoutes } from './app.routes.definition';
import { RIGHT_DRAWER_ROUTES } from './app.routes.right-drawer';

export const routes: Routes = [
    {
        path: NavigationRoutes.landingPage.path,
        title: NavigationRoutes.landingPage.title,
        component: LandingPageComponent,
        // An installed app cold-starts here (the manifest start_url); send it to its campaign instead.
        canActivate: [pwaLaunchGuard]
    },
    
    // {
    //     path: '',
    //     redirectTo: NavigationRoutes.sideNav.path,
    //     pathMatch: 'full'
    // },
    {
        path: 'login-failed',
        title: 'Login Failed',
        component: PageNotFoundComponent // Reuse this component or create a specific login failed component
    },
    {
        path: NavigationRoutes.sideNav.path,
        loadComponent() {
            return import('../components/side-nav/side-nav.component').then(m => m.SideNavComponent);
        },
        loadChildren: () => import('./app.routes.sidenav').then(m => m.SIDE_NAV_ROUTES),
        canActivate: [AbstractRouteGuard]
    },
    ...RIGHT_DRAWER_ROUTES,
    {
        path: NavigationRoutes.scanners.path,
        loadChildren: () => import('./app.routes.scanners').then(m => m.SCANNER_ROUTES)
    },
    {
        path: NavigationRoutes.viewers.path,
        loadChildren: () => import('./app.routes.viewers').then(m => m.VIEWER_ROUTES)
    },
    {
        path: NavigationRoutes.pageNotFound.path,
        title: NavigationRoutes.pageNotFound.title,
        component: PageNotFoundComponent
    }
];

